import socketIOClient from 'socket.io-client'
import { apiUrl } from './constants'

export const socket = socketIOClient(`${apiUrl}`)